import debounce from 'debounce'

const initSection = section => {
  let expanded  = false

  const inner   = section.querySelector('.press-section-inner')
  const actions = section.querySelector('.press-section-actions')
  const action  = section.querySelector('.press-section-action')
  const first   = section.querySelector('.press-section-item')

  const setInitialHeight = () => {
    if (document.documentElement.clientWidth >= 768)
      inner.style.height = first.offsetHeight + 'px'
    else
      inner.style.height = ''
  }

  const expand = () => {
    expanded = true
    inner.style.height = inner.scrollHeight + 'px'
  }

  const contract = () => {
    expanded = false
    inner.style.height = inner.scrollHeight + 'px'
    setTimeout(setInitialHeight, 10)
  }

  const afterExpand = () => {
    section.classList.add('press-section-expanded')
    inner.style.height = 'auto'
  }

  const afterContract = () =>
    section.classList.remove('press-section-expanded')

  const afterTransition = () =>
    expanded ? afterExpand() : afterContract()

  const toggleSection = () =>
    expanded ? contract() : expand()

  addEventListener('resize', debounce(setInitialHeight, 66))
  addEventListener('load', setInitialHeight)
  setTimeout(setInitialHeight, 66)

  inner.addEventListener('transitionend', afterTransition)
  action.addEventListener('click', toggleSection)
  actions.style.display = 'block'
}

const initPress = () => {
  document.querySelectorAll('.press-section').forEach(initSection)
}

$(initPress)
